require('./bootstrap');

import { createApp } from 'vue'
import router from './router'
import store from './store'
import App from '@/App.vue'
import mitt from 'mitt';
const emitter = mitt();
import { SetupCalendar } from 'v-calendar';

// Setup plugin for defaults or `$screens` (optional)

const appId = '#app'
const appEl = document.querySelector(appId);
const initialData = JSON.parse(appEl.dataset.init)

Object.keys(appEl.dataset).forEach(dataKey => {
    delete appEl.dataset[dataKey];
});

const app = createApp(App, { initialData: initialData });
app.config.globalProperties.$APP_URL = process.env.MIX_APP_URL
app.config.globalProperties.$CMS_URL = process.env.MIX_CMS_URL
app.config.globalProperties.$emitter = emitter;
app.use(SetupCalendar, {})
const components = require.context('@/components/Elements/', true, /\.vue$/i);
components.keys().map(key => app.component(key.split('/').pop().split('.')[0], components(key).default));
app.use(router);
app.use(store);
app.mount(appId);
/*
router.isReady().then(() => {
    app.mount(appId)
})
*/
